
export class NotificationService {
  private notificationContainer: HTMLElement | null;
  private notificationTitle: HTMLAnchorElement | null;
  private notificationText: HTMLElement | null;
  private notificationTimer: number | null = null;
  private notificationOverlay: HTMLElement | null;
  private notificationCloseTriggers: NodeListOf<HTMLElement>;

  constructor() {
    this.notificationContainer = document.querySelector('[data-notification]');
    this.notificationTitle = document.querySelector('[data-notification-title]');
    this.notificationText = document.querySelector('[data-notification-text]');
    this.notificationOverlay = document.querySelector('[data-notification-overlay]');
    this.notificationCloseTriggers = document.querySelectorAll('[data-notification-close]');

    this.notificationCloseTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        this.notificationContainer?.classList.remove('active');
        this.notificationOverlay?.classList.remove('active');
      });
    });
  }

  public displayNotification(payload: any) {
    if (!this.notificationContainer || !this.notificationTitle || !this.notificationText || !payload.notification) {
      return;
    }

    if (this.notificationTimer) {
      clearTimeout(this.notificationTimer);
    }

    const { title, body } = payload.notification;
    let link = payload.fcmOptions?.link || '#';
    if (!link.startsWith('http:') && !link.startsWith('https://')) {
      link = '#';
    }

    // On met à jour le contenu HTML
    this.notificationTitle.textContent = title;
    this.notificationTitle.href = link;
    this.notificationText.textContent = body;

    this.notificationContainer.classList.add('active');
    this.notificationOverlay?.classList.add('active');

    this.notificationTimer = window.setTimeout(() => {
      this.notificationContainer?.classList.remove('active');
      this.notificationOverlay?.classList.remove('active');
    }, 20000); //  20 secondes

  }
}

